import {RatesType} from 'app/store/DepositsStore';
import {fixed2} from 'app/utils/fixed';
import {getRateByCurrency} from './getRateByCurrency';

export const calculateAmountBySelectedCurrency = (amount: string, currency: string, rates: RatesType): string => {
    const rate = getRateByCurrency(currency, rates);

    return rate ? fixed2(Number(amount) / rate) : amount;
};
